export const getInteractionRelevantFields = () => {
  const fields = new Set(['state', 'attributes', 'displayName']);

  return fields;
};
